(ns frontend.view.entity-viewers.modules.entity-esign.sub
  (:require
    [common.schema.entities.pipeline :as pipeline]
    [common.util :as cu]
    [re-frame.core :as rf]))

(rf/reg-sub
  ::configurations
  (fn [db [_]]
    (::configurations db)))

(rf/reg-sub
  ::configurations-loaded?
  (fn [db [_]]
    (::configurations-loaded? db)))

(rf/reg-sub
  ::esign-configured-for-entity?
  :<- [::configurations]
  (fn [configurations [_ entity]]
    (let [entity-type (:entity/type entity)
          entity-pipeline-id (pipeline/entity-pipeline entity)]
      (if entity-pipeline-id
        (->> configurations
             (some (fn [target]
                     (= (:db/id target) entity-pipeline-id))))
        (->> configurations
             (some (fn [target]
                     (= (:entity/type target) entity-type))))))))

(rf/reg-sub
  ::signatories
  (fn [db [_]]
    (::signatories db)))

(rf/reg-sub
  ::esign-processes
  (fn [db [_]]
    (::esign-processes db)))

(rf/reg-sub
  ::attachments
  (fn [db [_]]
    (::attachments db)))

(rf/reg-sub
  ::non-cancelled-processes
  :<-
  [::esign-processes]
  :<-
  [::signatories]
  :<-
  [::attachments]
  (fn [[processes signatories attachments] [_ entity-id]]
    (let [id->signatory (->> entity-id
                             (get signatories)
                             (reduce
                               (fn [id->signatory signatory]
                                 (assoc id->signatory (:db/id signatory) signatory))
                               {}))
          id->attachment (->> entity-id
                              (get attachments)
                              (reduce
                                (fn [id->attachment attachment]
                                  (assoc id->attachment (:db/id attachment) attachment))
                                {}))
          esign-process (get processes entity-id)]

      (->> esign-process
           (cu/remove-by :esign-process/status :esign-process.status/canceled)
           (map (fn [p]
                  (let [signed? (= :esign-process.status/signed (:esign-process/status p))]
                    (-> p
                        (update :esign-process/signatories (partial map id->signatory))
                        (update :common/attachments
                                (fn [attachment-ids]
                                  (let [attachments (->> attachment-ids
                                                         (map id->attachment)
                                                         (remove nil?))
                                        signed-attachment (->> attachments
                                                               (filterv (fn [attachment]
                                                                          (some #{:esign-attachment/signed} (:common/system-kws attachment))))
                                                               first)]
                                    (if (and signed? signed-attachment)
                                      signed-attachment
                                      (->> attachments
                                           (sort-by :common/created-on)
                                           last)))))))))
           (sort-by :common/created-on)
           (reverse)
           (doall)))))

(rf/reg-sub
  ::reminding-signatory-ids
  (fn [db [_]]
    (::reminding-signatory-ids db)))
